import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppConstant } from '@app/core/constant/app-constant';
import { BigShortService } from '@app/public/shared/services/big-short.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  date: Date = new Date();
  readonly bigShortURL = AppConstant.StaticUrl.bigShortUrl;
  readonly careersURL = AppConstant.StaticUrl.careersUrl;
  abcStaticLink: string = environment.abc_static_link;
  filmfactoryStaticLink: string = environment.filmfactory_static_link;
  constructor(protected bigShortService: BigShortService) {}

  ngOnInit(): void {
    // empty init
  }
}
